export default {"src":"/_next/static/media/ellipse-steps.f281972b.svg","height":1302,"width":995,"blurWidth":0,"blurHeight":0};